// api.ts (o donde defines apiUrl)
import axios, { AxiosError } from 'axios'

export const apiUrl = axios.create({
  baseURL: process.env.REACT_APP_BACK_API_URL || 'https://phi-fm-api-qa.delfosti.site/api',
  headers: {
    Accept: 'application/json',
    'x-platform-request': 'WEB',
  },


  // opcional, pero útil para ver errores 4xx/5xx siempre en catch:
  validateStatus: (status) => status >= 200 && status < 300,
  
})

// —— Interceptor Request: añade token y loguea ——
apiUrl.interceptors.request.use((config: any) => {
  const token =
    localStorage.getItem('access_token') ||
    sessionStorage.getItem('access_token') ||
    undefined

  if (token) {
    // Asegura Authorization en cada request
    if (!config.headers) {
      config.headers = {} as any
    }
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

// —— Interceptor Response: logs y decoder de errores ——
apiUrl.interceptors.response.use(
  (response) => {
    return response
  },
  async (error: AxiosError) => {
    return Promise.reject(error)
  }
)
